/**
 * Get current locale from document
 */
export const getCurrentLocale = (): string => {
  return document.documentElement.lang || 'de'
}

/**
 * Get localized value from a multilingual field
 * Handles both string values (legacy) and object values (new multilingual format)
 */
export const getLocalizedValue = (
  value: string | Record<string, string> | null | undefined,
  fallback: string = ''
): string => {
  if (!value) return fallback

  // If it's already a string, return it
  if (typeof value === 'string') return value

  // If it's an object with language keys, get the localized version
  if (typeof value === 'object') {
    const locale = getCurrentLocale()
    return value[locale] || value['en'] || Object.values(value)[0] || fallback
  }

  return fallback
}

/**
 * Get localized product name
 */
export const getProductName = (product: { name: string | Record<string, string> }): string => {
  return getLocalizedValue(product.name, '')
}

/**
 * Get localized product short description
 */
export const getProductShortDescription = (
  product: { shortDescription?: string | Record<string, string> | null }
): string | null => {
  if (!product.shortDescription) return null
  return getLocalizedValue(product.shortDescription) || null
}

/**
 * Get localized product description
 */
export const getProductDescription = (
  product: { description?: string | Record<string, string> | null }
): string | null => {
  if (!product.description) return null
  return getLocalizedValue(product.description) || null
}
